var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiRequest, withDefaultHeaders } from "../../../lib";
import { getDatafanHeaders } from "./datafan_headers";
import { getDatafanToken, refreshDatafanToken } from "./datafan_token";
const apiRequestWithDatafanHeaders = withDefaultHeaders(getDatafanHeaders, apiRequest);
export const apiDatafanHandleTokenRefresh = (requestFunc) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return yield requestFunc();
    }
    catch (clause) {
        const failureApi = clause;
        if (failureApi.code !== "API__INTERNAL__403_FORBIDDEN" &&
            failureApi.code !== "API__INTERNAL__401_UNAUTHORIZED") {
            throw failureApi;
        }
        yield refreshDatafanToken();
        return requestFunc();
    }
});
export const apiRequestDatafan = (requestParams, errorToFailureHash) => __awaiter(void 0, void 0, void 0, function* () {
    if (!getDatafanToken()) {
        yield refreshDatafanToken();
    }
    return apiDatafanHandleTokenRefresh(() => apiRequestWithDatafanHeaders(requestParams, errorToFailureHash));
});
//# sourceMappingURL=datafan_request.js.map